import {datadogLogs} from '@datadog/browser-logs'

let currentJourneyId = null

const initDatadogConsoleLogger = () => {
  datadogLogs.init({
    clientToken: 'pubd140329fb40780b911662482247a94d4',
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    service: window.location.hostname,
    beforeSend: (log) => {
      const stack = log.error?.stack || ''
      if (stack.includes('.user.js') || stack.includes('chrome-extension://') || stack.includes('moz-extension://')) {
        return false
      }
      return true
    },
  });
}

const setJourneyContext = (journeyId) => {
  currentJourneyId = journeyId
  datadogLogs.setGlobalContextProperty('journeyId', journeyId)
}

const withJourneyId = (message) =>
  currentJourneyId ? `[${currentJourneyId}] ${message}` : message

const datadogLogger = {
  info:  (message, context) => datadogLogs.logger.info(withJourneyId(message), context),
  error: (message, context) => datadogLogs.logger.error(withJourneyId(message), context),
  warn:  (message, context) => datadogLogs.logger.warn(withJourneyId(message), context),
  debug: (message, context) => datadogLogs.logger.debug(withJourneyId(message), context),
}

export {initDatadogConsoleLogger, setJourneyContext, datadogLogger}
